export default __webpack_public_path__ + "static/media/Employees.43e71553.svg";